export default "__VITE_ASSET__Cr02sxEN__"